import { render, staticRenderFns } from "./DetailPanel.vue?vue&type=template&id=606c2d48&scoped=true"
import script from "./DetailPanel.vue?vue&type=script&lang=ts"
export * from "./DetailPanel.vue?vue&type=script&lang=ts"
import style0 from "./DetailPanel.vue?vue&type=style&index=0&id=606c2d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c2d48",
  null
  
)

export default component.exports